import { ExpandedState } from "@tanstack/react-table";

const DEFAULT_EXPANDED_STATE: ExpandedState = {
  0: true,
  1: true,
};

export { DEFAULT_EXPANDED_STATE };
